import React, { useState } from "react";
import styles from "./index.module.scss";
import { Link } from "../../../../shared/ui/Link";
import { Input } from "../../../../shared/ui/Input";
import { Button } from "../../../../shared/ui/Button";
import { updateOfferVisitorCardNum } from "../../../../shared/store/payment/api";
import { useAppSelector } from "../../../../shared/store";

const MAX_CARD_NUM_LENGTH = 16;

export const ClarifyCardNum = () => {
  const offerData = useAppSelector((state) => state.payment.offer);

  const [card, setCard] = useState("");
  const changeCard = (val: string) => {
    setCard(val);
  };
  const [isReqSending, setReqStatus] = useState(false);

  const updateCardReq = async () => {
    if (offerData) {
      setReqStatus(true);
      const resp = await updateOfferVisitorCardNum(offerData.id, card);
      setReqStatus(false);
    }
  };

  const isCardNumValid = card.length === MAX_CARD_NUM_LENGTH;
  return (
    <div className={styles.form_container}>
      {" "}
      <div className={styles.form}>
        <h2 className={styles.form_title}>Введите номер карты</h2>
        <p className={styles.form_descr}>
          Укажите верный номер карты отправителя средств для идентификации
          платежа
        </p>
        <div className={styles.bank_details_container}>
          <div className={styles.input_wrapper}>
            <Input
              value={card}
              onChange={changeCard}
              mask="0000 0000 0000 0000"
            />
          </div>
        </div>
        <Button
          content="Далее"
          disabled={!isCardNumValid || isReqSending}
          onClick={updateCardReq}
        />
      </div>
      <Link
        variant="hollow"
        content="Вернуться на сайт"
        className={styles.btn}
        href=""
        target="_blank"
      />
    </div>
  );
};
